import { useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "@/src/components/Header/Header";
import Sidebar from "@/src/components/Sidebar/Sidebar";
import AccessControlBootstrap from "@/src/components/AccessControl/AccessControlBootstrap";
import { useSelector } from "react-redux";
import { RootState } from "./store";
import Preloyder from "./components/Preloyder/Preloyder";

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const mainContentRef = useRef<HTMLDivElement>(null);
  const { isPreloyder } = useSelector((state: RootState) => state.Preloyder);
  const isSidebarOpen = useSelector((state: RootState) => state.sideBarMenu.isSidebarOpen);
  const isTablePage = ["/applications", "/tasks", "/office-accounting"].includes(location.pathname);

  useEffect(() => {
    document.body.classList.toggle("sidebar-collapsed", !isSidebarOpen);

    return () => {
      document.body.classList.remove("sidebar-collapsed");
    };
  }, [isSidebarOpen]);

  useEffect(() => {
    mainContentRef.current?.scrollTo(0, 0);
  }, [location.pathname]);

  // Проверка авторизации
  const accessToken = localStorage.getItem("accessToken") ? localStorage.getItem("accessToken") : "";
  const userLogin = localStorage.getItem("userLogin") ? localStorage.getItem("userLogin") : "";

  useEffect(() => {
    const rawUser = localStorage.getItem("userAuthInfo");
    if (rawUser) {
      try {
        const user = JSON.parse(rawUser);
        console.log("[User] full user object on reload:", user);
        return;
      } catch (error) {
        console.error("[User] Failed to parse userAuthInfo:", error);
      }
    }

    // Fallback for sessions before userAuthInfo started being saved — re-login to get full object.
    let userConfig: unknown = null;
    try {
      const rawConfig = localStorage.getItem("userConfig");
      userConfig = rawConfig ? JSON.parse(rawConfig) : null;
    } catch {
      userConfig = null;
    }

    let userID: unknown = null;
    try {
      const rawId = localStorage.getItem("userID");
      userID = rawId ? JSON.parse(rawId) : null;
    } catch {
      userID = localStorage.getItem("userID");
    }

    console.log("[User] assembled user object on reload (re-login for full sign-in payload):", {
      access_token: localStorage.getItem("accessToken"),
      login: localStorage.getItem("userLogin"),
      role: localStorage.getItem("userRole"),
      user_id: userID,
      config: userConfig,
    });
  }, []);

  useEffect(() => {
    if (!accessToken && location.pathname !== "/login") {
      navigate("/login", { replace: true });
    }
    if (accessToken && location.pathname === "/login") {
      navigate("/", { replace: true });
    }
  }, [accessToken, location.pathname, navigate]);

  // Если страница логина, не рендерим лэйаут
  if (location.pathname === "/login") {
    return <Outlet />;
  }

  return (
    <>
      <AccessControlBootstrap />
      <div id="modal-root" />
      <Sidebar />
      <section className="main">
        <Header username={userLogin} />
        <div className="main-content" ref={mainContentRef}>
          {isPreloyder && <Preloyder mode={isTablePage ? "content" : "fullscreen"} />}
          <Outlet />
        </div>
      </section>
    </>
  );
};

export default Layout;
